import { RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../Helpers/GlobalHelper';

let productoId = undefined;
let productoVisaId = undefined;
let productoCabalId = undefined;

let ProductoManager = function () {
    const agregarProducto = (x => x.Checked && x.Id > 0);
    const editarProducto = (x => (x.Id > 0 && x.Cambio) || (x.Id > 0 && x.noDisponible)); //NO SOLO DEBE RECONOCER CAMBIOS SINO RELACIONES A ELIMINAR POR SER ITEMS INACTIVOS
    const validarIds = (id) => (id > 0 ? id : null);

    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _guardarProducto(data, sagasCallback, viewCallback) {
        ejecutarSagasProducto(data, sagasCallback, viewCallback)
    }


    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagasProducto(data, sagasCallback, viewCallback) {
        let admId = data.GET_ADMINISTRADORA.find(x => x.Abreviatura === data.selectedAdministrator).Id;
        data.AdministradoraId = admId;
        switch (admId) {
            case 1: //VISA
                let localValuesVisa = agregarProductoVisa(data);
                ejecutarSagas(localValuesVisa, 'PRODUCTO_VISA', sagasCallback, viewCallback);
                break;
            case 2: //CABAL
                let localValuesCabal = agregarProductoCabal(data);
                ejecutarSagas(localValuesCabal, 'PRODUCTO_CABAL', sagasCallback, viewCallback);
                break;
        }
    }

    /**
     * 
     * @param {any} data
     */
    function agregarProductoVisa(data) {
        /*no remover hasta haber cerrado la tarea de modificacion*/
        if (data.Id != undefined)
            productoId = data.Id;

        if (data.productoVisaId != undefined)
            productoVisaId = data.productoVisaId;


        let localValues = {
            "PRODUCTO_CONTAINER": {
                "Producto": {
                    "Id": data.Id,
                    "AdministradoraId": data.AdministradoraId,
                    "Nombre": data.Nombre,
                    "EstaHabilitado": data.EstaHabilitado,
                    "TipoProductoId": validarIds(data.TipoProductoId),
                    "TipoCorrespondenciaId": validarIds(data.TipoCorrespondenciaId),
                    "UsuarioAlta": productoId ? data.UsuarioAlta : data.UsuarioModif,
                    "FechaAlta": productoId ? data.FechaAlta : GlobalHelper.DateBD(),
                    "UsuarioUltimaModificacion": data.UsuarioModif,
                    "FechaUltimaModificacion": GlobalHelper.DateBD(),
                    "ProductoCarteras": [],
                    "ProductoFormasDebito": [],
                    "ProductoFormasPago": [],
                    "ProductoGruposAfinidad": [],
                    "ProductoLimitesCompra": [],
                    "ProductoModelosLiquidacion": [],
                    "ProductoSucursales": [],
                    "ProductoCategoriasATM": [],
                    "ProductoCodigosDistribucion": [],
                    "ProductoLineasPrestamo": [],
                    "ProductoModalidadesDistribucionLimite": [],
                    "ProductoComercializadoraCanales": [],
                    "ProductoHabilitacionTarjetas": []
                },
                "ProductoVisa": {
                    "Id": validarIds(data.ProductoVisaId),
                    "NuevosAtributos": data.NuevosAtributos,
                    "AsociaGrupoAfinidad": data.AsociaGrupoAfinidad,
                    "TipoGrabadoCuartaLinea": data.TipoGrabadoCuartaLinea ? data.TipoGrabadoCuartaLinea : null,
                    "TextoCuartaLinea": data.TextoCuartaLinea ? data.TextoCuartaLinea : null,
                    "UtilizaCodigoDistribucion": data.UtilizaCodigoDistribucion,
                    "HabilitaComercializadora": data.HabilitaComercializadora,
                    "CostoEmision": data.CostoEmision,
                    "PorcBonificacionEmisionDesde": data.PorcBonificacionEmisionDesde,
                    "PorcBonificacionEmisionHasta": data.PorcBonificacionEmisionHasta,
                    "CargoEnCuotas": data.CargoEnCuotas,
                    "CargoEnCuotasDesde": data.CargoEnCuotasDesde,
                    "CargoEnCuotasHasta": data.CargoEnCuotasHasta,
                    "TipoLimiteIndividuos": data.TipoLimiteIndividuos,
                    "LimiteCompraMaximo": data.LimiteCompraMaximo ? parseFloat(data.LimiteCompraMaximo) : null,
                    "FLCCxCuenta": data.FLCCxCuenta,
                    "FLCCDesde": data.FLCCDesde,
                    "FLCCHasta": data.FLCCHasta,
                    "LimiteFinanciacionxCuenta": data.LimiteFinanciacionxCuenta,
                    "LimiteFinanciacionDesde": data.LimiteFinanciacionDesde,
                    "LimiteFinanciacionHasta": data.LimiteFinanciacionHasta,
                    "UsoATM": data.UsoATM,
                    "SolicitudEstadoId": validarIds(data.SolicitudEstadoId)
                },
                "ProductoVisaDefault": {
                    "Id": validarIds(data.ProductoDefaultId),
                    "GrupoAfinidadDefaultId": validarIds(data.GrupoAfinidadDefaultId),
                    "GrupoAfinidadDefaultInterfaz": data.AsociaGrupoAfinidad ? data.GrupoAfinidadDefaultInterfaz : null,
                    "CodigoDistribucionDefaultId": validarIds(data.CodigoDistribucionDefaultId),
                    "CodigoDistribucionDefaultInterfaz": data.UtilizaCodigoDistribucion ? data.CodigoDistribucionDefaultInterfaz : null,
                    "BonificacionEmisionDefault": validarIds(data.BonificacionEmisionDefault),
                    "BonificacionEmisionDefaultIntefaz": data.CostoEmision == "BP" ? data.BonificacionEmisionDefaultIntefaz : null,
                    "ComercializadoraCanalDefaultId": data.HabilitaComercializadora ? data.ComercializadoraCanalDefaultId : null,
                    "ComercializadoraCanalDefaultInterfaz": data.HabilitaComercializadora ? data.ComercializadoraCanalDefaultInterfaz : null,
                    "CuotasDefault": data.CuotasDefault,
                    "CuotasDefaultInterfaz": data.CargoEnCuotas ? data.CuotasDefaultInterfaz : null,
                    "DistribucionLimiteDefaultId": validarIds(data.DistribucionLimiteDefaultId),
                    "DistribucionLimiteDefaultInterfaz": data.DistribucionLimiteDefaultInterfaz,
                    "LimiteCompraDefaultId": data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.some(tipo => tipo.Checked && tipo.TipoLimite == "L") ? validarIds(data.LimiteCompraDefaultId) : null,
                    "LimiteCompraDefaultIntefaz": data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.some(tipo => tipo.Checked && tipo.TipoLimite == "L") ? data.LimiteCompraDefaultIntefaz : null,
                    "FLCCDefault": data.FLCCxCuenta ? data.FLCCDefault : null,
                    "FLCCDefaultInterfaz": data.FLCCxCuenta ? data.FLCCDefaultInterfaz : null,
                    "LimitePrestamoDefaultId": (data.GET_PARAMETRO_GENERAL.SINOLINEAPRESTAMOS && data.GET_LINEA_PRESTAMO.some(l => l.Checked)) ? validarIds(data.LimitePrestamoDefaultId) : null,
                    "LimitePrestamoDefaultInterfaz": (data.GET_PARAMETRO_GENERAL.SINOLINEAPRESTAMOS && data.GET_LINEA_PRESTAMO.some(l => l.Checked)) ? data.LimitePrestamoDefaultInterfaz : null,
                    "LimiteFinanciacionDefault": data.LimiteFinanciacionxCuenta ? data.LimiteFinanciacionDefault : null,
                    "LimiteFinanciacionDefaultInterfaz": data.LimiteFinanciacionxCuenta ? data.LimiteFinanciacionDefaultInterfaz : null,
                    "CarteraDefaultId": validarIds(data.CarteraDefaultId),
                    "CarteraDefaultInterfaz": data.CarteraDefaultInterfaz,
                    "ModeloLiquidacionDefaultId": validarIds(data.ModeloLiquidacionDefaultId),
                    "ModeloLiquidacionDefaultInterfaz": data.ModeloLiquidacionDefaultInterfaz,
                    "CategoriaCajeroDefaultId": (data.GET_PARAMETRO_GENERAL.SINOREDBANELCO && data.GET_CATEGORIA_CAJERO.some(l => l.Checked)) ? validarIds(data.CategoriaCajeroDefaultId) : null,
                    "CategoriaCajeroDefaultInterfaz": (data.GET_PARAMETRO_GENERAL.SINOREDBANELCO && data.GET_CATEGORIA_CAJERO.some(l => l.Checked)) ? data.CategoriaCajeroDefaultInterfaz : null,
                    "HabilitacionCajerosDefaultId": (data.GET_PARAMETRO_GENERAL.SINOREDBANELCO) ? validarIds(data.HabilitacionCajerosDefaultId) : null,
                    "HabilitacionCajerosDefaultInterfaz": (data.GET_PARAMETRO_GENERAL.SINOREDBANELCO) ? data.HabilitacionCajerosDefaultInterfaz : null,
                    "FormaPagoDefaultId": validarIds(data.FormaPagoDefaultId),
                    "FormaPagoDefaultInterfaz": data.FormaPagoDefaultInterfaz,
                    "TipoDebitoDefaultId": (data.TipoDebitoDefaultInterfaz && data.GET_FORMA_PAGO.some(forma => forma.EsDebitoEnCuenta && forma.Id == data.FormaPagoDefaultId)) ? validarIds(data.TipoDebitoDefaultId) : null,
                    "TipoDebitoDefaultInterfaz": data.GET_FORMA_PAGO.some(forma => forma.EsDebitoEnCuenta && forma.Id == data.FormaPagoDefaultId) ? data.TipoDebitoDefaultInterfaz : null
                }
            }
        }

        let callback = (productoId == 0 || productoId == null) ? agregarProducto : editarProducto;

        //PARA LOS CAMPOS QUE SE HABILITAN O NO CON UN CHECK (POR EJEMPLO GRUPO DE AFINIDAD), SI SE DESHABILITA SE LE PASA EL ARREGLO ENTERO A LA FUNCION PARA QUE ELIMINE TODAS LAS RELACIONES EN LA MODIFICACIÓN.

        agregarProductoCarteras(data.GET_CARTERAS.filter(x => callback(x)), localValues);
        agregarProductoFormasDebito(data.GET_FORMA_DEBITO.filter(x => callback(x)), localValues, data);
        agregarProductoFormasPago(data.GET_FORMA_PAGO.filter(x => callback(x)), localValues);
        (!data.AsociaGrupoAfinidad && callback == editarProducto) ? agregarProductoGruposAfinidad(data.GET_GRUPO_AFINIDAD_ADMINISTRADORA, localValues) : agregarProductoGruposAfinidad(data.GET_GRUPO_AFINIDAD_ADMINISTRADORA.filter(x => callback(x)), localValues);
        agregarProductoLimitesCompra(data.GET_LIMITE_COMPRA.filter(x => callback(x)), localValues);
        agregarProductoModelosLiquidacion(data.GET_MODELO_LIQUIDACION_ADMINISTRADORA.filter(x => callback(x)), localValues);
        agregarProductoSucursales(data.GET_SUCURSAL.filter(x => callback(x)), localValues);
        agregarProductoCategoriasATM(data.GET_CATEGORIA_CAJERO.filter(x => callback(x)), localValues);
        (!data.UtilizaCodigoDistribucion && callback == editarProducto) ? agregarProductoCodigosDistribucion(data.GET_CODIGO_DISTRIBUCION, localValues) : agregarProductoCodigosDistribucion(data.GET_CODIGO_DISTRIBUCION.filter(x => callback(x)), localValues);
        agregarProductoLineasPrestamo(data.GET_LINEA_PRESTAMO.filter(x => callback(x)), localValues);
        agregarProductoModalidadesDistribucionLimite(data.GET_MODALIDAD_DISTRIBUCION_LIMITE.filter(x => callback(x)), localValues);
        agregarProductoComercializadoraCanal(data.GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN, localValues);
        agregarProductoHabilitacionTarjetas(data.GET_ATLAS_HABILITACION_TARJETA.filter(x => callback(x)), localValues);
        agregarComercializadoraCanalDefault(data.ComercializadoraCanalDefaultIdFront, data, localValues)

        //Limpio las variables globales
        productoId = undefined;
        productoVisaId = undefined;
        
        return localValues;
    }

    /**
     * 
     * @param {any} data
     */
    function agregarProductoCabal(data) {

        /*no remover hasta haber cerrado la tarea de modificacion*/
        if (data.Id != undefined)
            productoId = data.Id;

        if (data.ProductoCabalId != undefined)
            productoCabalId = data.ProductoCabalId;



        let localValues = {
            "PRODUCTO_CONTAINER": {
                "Producto": {
                    "Id": data.Id,
                    "AdministradoraId": data.AdministradoraId,
                    "Nombre": data.Nombre,
                    "EstaHabilitado": data.EstaHabilitado,
                    "TipoProductoId": data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA[0] && data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA[0].Id,
                    "TipoCorrespondenciaId": validarIds(data.TipoCorrespondenciaId),
                    "UsuarioAlta": productoId ? data.UsuarioAlta : data.UsuarioModif,
                    "FechaAlta": productoId ? data.FechaAlta : GlobalHelper.DateBD(),
                    "UsuarioUltimaModificacion": data.UsuarioModif,
                    "FechaUltimaModificacion": GlobalHelper.DateBD(),
                    "ProductoCarteras": [],
                    "ProductoFormasDebito": [],
                    "ProductoFormasPago": [],
                    "ProductoGruposAfinidad": [],
                    "ProductoSucursales": [],
                    "ProductoMarcasCompartidas": [],
                    "ProductoSegmentosCarteras": []
                },
                "ProductoCabal": {
                    "Id": validarIds(data.ProductoCabalId),
                    "AsociaGrupoAfinidad": data.AsociaGrupoAfinidad,
                    "AsociaSegmentoCartera": data.AsociaSegmentoCartera,
                    "AsociaMarcaCompartida": data.AsociaMarcaCompartida,
                    "TipoGrabadoCuartaLinea": data.HabilitaCuartaLinea ? data.TipoGrabadoCuartaLinea : null,
                    "TextoCuartaLinea": (data.HabilitaCuartaLinea && data.TipoGrabadoCuartaLinea == "Texto") ? data.TextoCuartaLinea : null,
                    "PreEmision": null,
                    "ActivacionTelefonica": data.PermiteAccionTelefonica,
                    "LimiteCompraDesde": data.limiteCompraCabalMin,
                    "LimiteCompraHasta": data.limiteCompraCabalMax,
                    "CLCCDesde": data.rangoCoeficienteMin,
                    "CLCCHasta": data.rangoCoeficienteMax,
                    "LimiteFinanciacionDesde": data.limiteFinanciacionCabalMin,
                    "LimiteFinanciacionHasta": data.limiteFinanciacionCabalMax,
                    "TopePagoMinimoXCuenta": data.establecerPorCuenta ? data.establecerPorCuenta : null,
                    "TopePagoMinimoDesde": data.topePagoMinimoCabalMin ? data.topePagoMinimoCabalMin : null,
                    "TopePagoMinimoHasta": data.topePagoMinimoCabalMax ? data.topePagoMinimoCabalMax : null,
                    "SolicitudEstadoId": validarIds(data.SolicitudEstadoId)

                },
                "ProductoCabalDefault": {
                    "Id": validarIds(data.ProductoVisaDefaultId),
                    "GrupoAfinidadDefaultId": data.GrupoAfinidadDefaultInterfaz ? validarIds(data.GrupoAfinidadDefaultId) : null,
                    "GrupoAfinidadDefaultInterfaz": data.GrupoAfinidadDefaultInterfaz,
                    "SegmentoCarteraDefaultId": data.SegmentoCarteraDefaultInterfaz ? validarIds(data.SegmentoCarteraDefaultId) : null,
                    "SegmentoCarteraDefaultInterfaz": data.SegmentoCarteraDefaultInterfaz,
                    "MarcaCompartidaDefaultId": data.MarcaCompartidaDefaultInterfaz ? validarIds(data.MarcaCompartidaDefaultId) : null,
                    "MarcaCompartidaDefaultInterfaz": data.MarcaCompartidaDefaultInterfaz,
                    "PreEmisionDefault": data.PreEmisionDefaultInterfaz ? saveDefaultConCero("PreEmisionDefault", data.PreEmisionDefaultId) : null,
                    "PreEmisionDefaultInterfaz": data.PreEmisionDefaultInterfaz,
                    "AltaPosdatadaDefault": data.AltaPosDatadaDefaultInterfaz ? (data.AltaPosDatadaDefaultId == 1 ? "S":"N") : null,
                    "AltaPosdatadaDefaultInterfaz": data.AltaPosDatadaDefaultInterfaz,
                    "RetencionTarjetaDefault": data.RetencionTarjetaDefaultInterfaz ? (data.RetencionTarjetaDefaultId == 1 ? "N":"E") : null,
                    "RetencionTarjetaDefaultInterfaz": data.RetencionTarjetaDefaultInterfaz,
                    "LimiteCompraDefault": data.LimiteCompraDefaultIntefaz ? validarIds(data.limiteCompraCabalDefault) : null,
                    "LimiteCompraDefaultIntefaz": data.limiteCompraCabalDefaultInterfaz,
                    "CLCCDefault": data.rangoCoeficienteDefaultInterfaz ? data.rangoCoeficienteDefault : null,
                    "CLCCDefaultInterfaz": data.rangoCoeficienteDefaultInterfaz,
                    "LimiteFinanciacionDefault": data.LimiteFinanciacionDefaultInterfaz ? data.limiteFinanciacionCabalDefault : null,
                    "LimiteFinanciacionDefaultInterfaz": data.LimiteFinanciacionDefaultInterfaz,
                    "TopePagoMinimoDefault": data.topePagoMinimoCabalDefaultInterfaz ? data.topePagoMinimoCabalDefault : null,
                    "TopePagoMinimoDefaultInterfaz": data.establecerPorCuenta ? data.topePagoMinimoCabalDefaultInterfaz : null,
                    "CicloFacturacionDefaultId": data.CarteraDefaultInterfaz ? validarIds(data.CarteraDefaultId) : null,
                    "CicloFacturacionDefaultInterfaz": data.CarteraDefaultInterfaz,
                    "FormaPagoDefaultId": data.FormaPagoDefaultInterfaz ? validarIds(data.FormaPagoDefaultId) : null,
                    "FormaPagoDefaultInterfaz": data.FormaPagoDefaultInterfaz,
                    "TipoDebitoDefaultId": (data.TipoDebitoDefaultInterfaz && data.GET_FORMA_PAGO.some(forma => forma.EsDebitoEnCuenta && forma.Id == data.FormaPagoDefaultId)) ? validarIds(data.TipoDebitoDefaultId) : null,
                    "TipoDebitoDefaultInterfaz": data.GET_FORMA_PAGO.some(forma => forma.EsDebitoEnCuenta && forma.Id == data.FormaPagoDefaultId) ? data.TipoDebitoDefaultInterfaz : null
                }
            }
        }

        let callback = (productoId == 0 || productoId == null || productoId == undefined) ? agregarProducto : editarProducto;

        //PARA LOS CAMPOS QUE SE HABILITAN O NO CON UN CHECK (POR EJEMPLO GRUPO DE AFINIDAD), SI SE DESHABILITA SE LE PASA EL ARREGLO ENTERO A LA FUNCION PARA QUE ELIMINE TODAS LAS RELACIONES EN LA MODIFICACIÓN.

        agregarProductoCarteras(data.GET_CARTERAS.filter(x => callback(x)), localValues);
        agregarProductoFormasDebito(data.GET_FORMA_DEBITO.filter(x => callback(x)), localValues, data);
        agregarProductoFormasPago(data.GET_FORMA_PAGO.filter(x => callback(x)), localValues);
        (!data.AsociaGrupoAfinidad && callback == editarProducto) ? agregarProductoGruposAfinidad(data.GET_GRUPO_AFINIDAD_ADMINISTRADORA, localValues) : agregarProductoGruposAfinidad(data.GET_GRUPO_AFINIDAD_ADMINISTRADORA.filter(x => callback(x)), localValues);
        agregarProductoSucursales(data.GET_SUCURSAL.filter(x => callback(x)), localValues);
        (!data.AsociaMarcaCompartida && callback == editarProducto) ? agregarProductoMarcaCompartida(data.GET_ATLAS_MARCA_COMPARTIDA, localValues) : agregarProductoMarcaCompartida(data.GET_ATLAS_MARCA_COMPARTIDA.filter(x => callback(x)), localValues);
        (!data.AsociaSegmentoCartera && callback == editarProducto) ? agregarProductoSegmentoCartera(data.GET_ATLAS_SEGMENTO_CARTERA, localValues) : agregarProductoSegmentoCartera(data.GET_ATLAS_SEGMENTO_CARTERA.filter(x => callback(x)), localValues);
        preEmisionCabal(data.GET_SENAL_PRE_EMISION_CABAL, localValues);
        altaPosdatadaCabal(data.GET_ALTA_POSDATADA, localValues);
        retencionTarjeta(data.GET_RETENCION_TARJETA_CABAL, localValues);

        //Limpio las variables globales
        productoId = undefined;
        productoCabalId = undefined;

        return localValues;
    }

    /** Convierte los valores guardados por las action al valor correspondiente en BD
     * 
     * @param {any} preEmisionArray
     * @param {any} localValues
     */
    function preEmisionCabal(preEmisionArray, localValues) {
        let arrAux = [];

        preEmisionArray.map(e => { if (e.Checked == true) arrAux.push(e.Id) });

        if (arrAux.includes(1) && !arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.PreEmision = 0
        if (!arrAux.includes(1) && arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.PreEmision = 1
        if (arrAux.includes(1) && arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.PreEmision = 2
        if (arrAux.length < 1) localValues.PRODUCTO_CONTAINER.ProductoCabal.PreEmision = null
    }

    /** Convierte los valores guardados por las action al valor correspondiente en BD
     * 
     * @param {any} posDatadaArray 
     * @param {any} localValues 
     */
    function altaPosdatadaCabal(posDatadaArray, localValues) {
        let arrAux = [];

        posDatadaArray.map(e => { if (e.Checked == true) arrAux.push(e.Id) });

        if (arrAux.includes(1) && !arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.AltaPosDatada = "S"
        if (!arrAux.includes(1) && arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.AltaPosDatada = "N"
        if (arrAux.includes(1) && arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.AltaPosDatada = "A"
        if (!arrAux.includes(1) && !arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.AltaPosDatada = null

    }

    /** Convierte los valores guardados por las action al valor correspondiente en BD
     * 
     * @param {any} retencionArray 
     * @param {any} localValues 
     */
    function retencionTarjeta(retencionArray, localValues) {
        let arrAux = [];

        retencionArray.map(e => { if (e.Checked == true) arrAux.push(e.Id) });

        if (arrAux.includes(1) && !arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.RetencionTarjeta = "N"
        if (!arrAux.includes(1) && arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.RetencionTarjeta = "E"
        if (arrAux.includes(1) && arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.RetencionTarjeta = "A"
        if (!arrAux.includes(1) && !arrAux.includes(2)) localValues.PRODUCTO_CONTAINER.ProductoCabal.RetencionTarjeta = null

    }

    /** Maneja los casos en que es necesario guardar el valor 0 en los defaults, ya que en instancias anteriores
     *  generar�a errores en la validaci�n.
     * @param {any} prop
     * @param {any} val
     */
    function saveDefaultConCero(prop, val) {
        if (prop == "PreEmisionDefault") {
            if (val == "1" || val == 0) {
                return false
            } else if (val == "2") {
                return true
            }
        }
    }

    /**
     * 
     * @param {any} categoriaATMs
     * @param {any} localValues
     */
    function agregarProductoCategoriasATM(categoriaATMs, localValues) {
        categoriaATMs.forEach(function (atm) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoCategoriasATM.push({
                "Id": atm.ProductoCategoriaAtmId,
                "CategoriaAtmId": atm.Id,
                "DeleteInstance": atm.noDisponible ? true : !atm.Checked
            });
        });
    }

    /**
     * 
     * @param {any} codDistribuciones
     * @param {any} localValues
     */
    function agregarProductoCodigosDistribucion(codDistribuciones, localValues) {
        let eliminarSelecciones = !localValues.PRODUCTO_CONTAINER.ProductoVisa.UtilizaCodigoDistribucion

        if (!eliminarSelecciones) {
            codDistribuciones.forEach(function (codDistribucion) {
                localValues.PRODUCTO_CONTAINER.Producto.ProductoCodigosDistribucion.push({
                    "Id": codDistribucion.ProductoCodigoDistribucionId,
                    "CodigoDistribucionId": codDistribucion.Id,
                    "DeleteInstance": codDistribucion.noDisponible ? true : !codDistribucion.Checked
                });
            });
        } else {
            codDistribuciones.forEach(function (codDistribucion) {
                if (codDistribucion.ProductoCodigoDistribucionId) {
                    localValues.PRODUCTO_CONTAINER.Producto.ProductoCodigosDistribucion.push({
                        "Id": codDistribucion.ProductoCodigoDistribucionId,
                        "CodigoDistribucionId": codDistribucion.Id,
                        "DeleteInstance": true
                    });
                }
            });

        }

    }

    /**
     * 
     * @param {any} lineaPrestamos
     * @param {any} localValues
     */
    function agregarProductoLineasPrestamo(lineaPrestamos, localValues) {
        lineaPrestamos.forEach(function (lineaPrestamo) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoLineasPrestamo.push({
                "Id": lineaPrestamo.ProductoLineaPrestamoId,
                "LineaPrestamoId": lineaPrestamo.Id,
                "DeleteInstance": lineaPrestamo.noDisponible ? true : !lineaPrestamo.Checked
            });
        });
    }

    /**
     * 
     * @param {any} modDistLimites
     * @param {any} localValues
     */
    function agregarProductoModalidadesDistribucionLimite(modDistLimites, localValues) {
        modDistLimites.forEach(function (modDistLimite) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoModalidadesDistribucionLimite.push({
                "Id": modDistLimite.ProductoModalidadDistribucionLimiteId,
                "ModalidadDistribucionLimiteId": modDistLimite.Id,
                "DeleteInstance": modDistLimite.noDisponible ? true : !modDistLimite.Checked
            });
        });
    }

    /**
     * 
     * @param {any} productoCarteras
     * @param {any} localValues
     */
    function agregarProductoCarteras(productoCarteras, localValues) {
        productoCarteras.forEach(function (productoCartera) {

            localValues.PRODUCTO_CONTAINER.Producto.ProductoCarteras.push({
                "Id": productoCartera.ProductoCarteraId,
                "CarteraId": productoCartera.Id,
                "DeleteInstance": productoCartera.noDisponible ? true : !productoCartera.Checked
            });
        });
    }

    /**
     * 
     * @param {any} formaPagos
     * @param {any} localValues
     */
    function agregarProductoFormasPago(formaPagos, localValues) {
        formaPagos.forEach(function (formaPago) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoFormasPago.push({
                "Id": formaPago.ProductoFormaPagoId,
                "FormaPagoId": formaPago.Id,
                "DeleteInstance": formaPago.noDisponible ? true : !formaPago.Checked
            });
        });
    }

    /**
     * 
     * @param {any} formaDebitos
     * @param {any} localValues
     */
    function agregarProductoFormasDebito(formaDebitos, localValues, data) {
        let eliminarTodas = !data.GET_FORMA_PAGO.some(forma => forma.EsDebitoEnCuenta && forma.Checked)

        if (eliminarTodas) {
            data.GET_FORMA_DEBITO.forEach(function (formaDebito) {
                if (formaDebito.ProductoFormaDebitoId) {
                    localValues.PRODUCTO_CONTAINER.Producto.ProductoFormasDebito.push({
                        "Id": formaDebito.ProductoFormaDebitoId,
                        "FormaDebitoId": formaDebito.Id,
                        "DeleteInstance": true
                    });
                }
            });
        } else {
            formaDebitos.forEach(function (formaDebito) {
                localValues.PRODUCTO_CONTAINER.Producto.ProductoFormasDebito.push({
                    "Id": formaDebito.ProductoFormaDebitoId,
                    "FormaDebitoId": formaDebito.Id,
                    "DeleteInstance": formaDebito.noDisponible ? true : !formaDebito.Checked
                });
            });
        }
    }

    /**
     * 
     * @param {any} sucursales
     * @param {any} localValues
     */
    function agregarProductoSucursales(sucursales, localValues) {
        sucursales.forEach(function (sucursal) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoSucursales.push({
                "Id": sucursal.ProductoSucursalId,
                "SucursalId": sucursal.Id,
                "DeleteInstance": !sucursal.Checked
            });
        });
    }

    /**
     * 
     * @param {any} marcas
     * @param {any} localValues
     */
    function agregarProductoMarcaCompartida(marcas, localValues) {
        let eliminarSelecciones = !localValues.PRODUCTO_CONTAINER.ProductoCabal.AsociaMarcaCompartida

        if (!eliminarSelecciones) {
            marcas.forEach(function (marca) {
                localValues.PRODUCTO_CONTAINER.Producto.ProductoMarcasCompartidas.push({
                    "Id": marca.ProductoMarcaCompartidaId,
                    "MarcaCompartidaId": marca.Id,
                    "DeleteInstance": marca.noDisponible ? true : !marca.Checked
                });
            });
        } else {
            marcas.forEach(function (marca) {
                if (marca.ProductoMarcaCompartidaId) {
                    localValues.PRODUCTO_CONTAINER.Producto.ProductoMarcasCompartidas.push({
                        "Id": marca.ProductoMarcaCompartidaId,
                        "MarcaCompartidaId": marca.Id,
                        "DeleteInstance": true
                    });
                }
            });
        }
    }

    /**
    * 
    * @param {any} segmentoCarteras
    * @param {any} localValues
    */
    function agregarProductoSegmentoCartera(segmentoCarteras, localValues) {
        let eliminarSelecciones = !localValues.PRODUCTO_CONTAINER.ProductoCabal.AsociaSegmentoCartera

        if (!eliminarSelecciones) {
            segmentoCarteras.forEach(function (segmentoCartera) {
                localValues.PRODUCTO_CONTAINER.Producto.ProductoSegmentosCarteras.push({
                    "Id": segmentoCartera.ProductoSegmentoCarteraId,
                    "SegmentoCarteraId": segmentoCartera.Id,
                    "DeleteInstance": segmentoCartera.noDisponible ? true : !segmentoCartera.Checked
                });
            });
        } else {
            segmentoCarteras.forEach(function (segmentoCartera) {
                if (segmentoCartera.ProductoSegmentoCarteraId) {
                    localValues.PRODUCTO_CONTAINER.Producto.ProductoSegmentosCarteras.push({
                        "Id": segmentoCartera.ProductoSegmentoCarteraId,
                        "SegmentoCarteraId": segmentoCartera.Id,
                        "DeleteInstance": true
                    });
                }
            });
        }
    }

    /**
     * 
     * @param {any} grupoAfinidades
     * @param {any} localValues
     */
    function agregarProductoGruposAfinidad(grupoAfinidades, localValues) {
        let eliminarSelecciones = false;

        if ((localValues.PRODUCTO_CONTAINER.ProductoCabal && !localValues.PRODUCTO_CONTAINER.ProductoCabal.AsociaGrupoAfinidad) || (localValues.PRODUCTO_CONTAINER.ProductoVisa && !localValues.PRODUCTO_CONTAINER.ProductoVisa.AsociaGrupoAfinidad)) {
            eliminarSelecciones = true;
        }
        if (!eliminarSelecciones) {
            grupoAfinidades.forEach(function (grupoAfinidad) {
                localValues.PRODUCTO_CONTAINER.Producto.ProductoGruposAfinidad.push({
                    "Id": grupoAfinidad.ProductoGrupoAfinidadId,
                    "GrupoAfinidadId": grupoAfinidad.Id,
                    "DeleteInstance": grupoAfinidad.noDisponible ? true : !grupoAfinidad.Checked
                });
            });
        } else {
            grupoAfinidades.forEach(function (grupoAfinidad) {
                if (grupoAfinidad.ProductoGrupoAfinidadId) {
                    localValues.PRODUCTO_CONTAINER.Producto.ProductoGruposAfinidad.push({
                        "Id": grupoAfinidad.ProductoGrupoAfinidadId,
                        "GrupoAfinidadId": grupoAfinidad.Id,
                        "DeleteInstance": true
                    });
                }
            });
        }
    }

    /**
     * 
     * @param {any} modeloLiquidaciones
     * @param {any} localValues
     */
    function agregarProductoModelosLiquidacion(modeloLiquidaciones, localValues) {
        modeloLiquidaciones.forEach(function (modeloLiquidacion) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoModelosLiquidacion.push({
                "Id": modeloLiquidacion.ProductoModeloLiquidacionId,
                "ModeloLiquidacionId": modeloLiquidacion.Id,
                "DeleteInstance": !modeloLiquidacion.Checked
            });
        });
    }

    /**
     * 
     * @param {any} limiteCompras
     * @param {any} localValues
     */
    function agregarProductoLimitesCompra(limiteCompras, localValues) {

        limiteCompras.forEach(function (limiteCompra) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoLimitesCompra.push({
                "Id": limiteCompra.ProductoLimiteCompraId,
                "LimiteCompraId": limiteCompra.Id,
                "DeleteInstance": !limiteCompra.Checked
            });
        });
    }

    /**
     * 
     * @param {any} habilitacionTarjetas
     * @param {any} localValues
     */
    function agregarProductoHabilitacionTarjetas(habilitacionTarjetas, localValues) {
        habilitacionTarjetas.forEach(function (hablitacionTarjeta) {
            localValues.PRODUCTO_CONTAINER.Producto.ProductoHabilitacionTarjetas.push({
                "Id": hablitacionTarjeta.ProductoHabilitacionTarjetaId,
                "HabilitacionTarjetaId": hablitacionTarjeta.Id,
                "DeleteInstance": !hablitacionTarjeta.Checked
            });
        });
    }

    /**
     * 
     * @param {any} comercializadoraCanales
     * @param {any} localValues
     */
    function agregarProductoComercializadoraCanal(comercializadoraCanales, localValues) {
        let eliminarSelecciones = !localValues.PRODUCTO_CONTAINER.ProductoVisa.HabilitaComercializadora
        if (!eliminarSelecciones) {
            comercializadoraCanales.forEach(function (comercializadoraCanal) {
                /*apartir de este nivel hay que empezar a guardar el id de RelacionId de los canales de venta*/
                comercializadoraCanal.CanalVentas.filter(ccv => ccv.Cambio).forEach(ccv2 => {
                    localValues.PRODUCTO_CONTAINER.Producto.ProductoComercializadoraCanales.push({
                        "Id": ccv2.ComercializadoraCanalId,
                        "ComercializadoraCanalId": ccv2.RelacionId,
                        "DeleteInstance": !ccv2.Checked

                    });
                });
            });
        } else {
            comercializadoraCanales.forEach(function (comercializadoraCanal) {//ESTA CONDICIÓN SE DA CUANDO SE DESTILDA "HABILITAR COMERCIALIZADORA"
                /*apartir de este nivel hay que empezar a guardar el id de RelacionId de los canales de venta*/
                comercializadoraCanal.CanalVentas.filter(ccv => ccv.Cambio).forEach(ccv2 => {
                    if (ccv2.ComercializadoraCanalId && ccv2.RelacionId) {
                        localValues.PRODUCTO_CONTAINER.Producto.ProductoComercializadoraCanales.push({
                            "Id": ccv2.ComercializadoraCanalId,
                            "ComercializadoraCanalId": ccv2.RelacionId,
                            "DeleteInstance": true
                        });
                    }
                });
            });

        }
    }

    /**
     * 
     * @param {any} idFront
     * @param {any} data
     * @param {any} localValues
     */
    function agregarComercializadoraCanalDefault(idFront, data, localValues) {
        if (idFront && isNaN(idFront)) {
            let com = idFront.split("-")[0]
            let can = idFront.split("-")[1]

            data.GET_COMERCIALIZADORA_CANAL_VENTA_BY_ADMIN.map(comercializadora => {
                if (comercializadora.Id == com) {
                    comercializadora.CanalVentas.map(canal => {
                        if (canal.Id == can) {
                            localValues.PRODUCTO_CONTAINER.ProductoVisaDefault.ComercializadoraCanalDefaultId = canal.RelacionId
                        }
                    })
                }
            })
        }
    }

    /**
     * 
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {
        
        SagasProxy.AddSagaRequests(localValues, saga, "TARJETAS", "ADMINPRODUCTOS");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, "ADMINPRODUCTOS");
    }
   
    return {
        GuardarProducto: function (data, sagasCallback, viewCallback) {
            return _guardarProducto(data, sagasCallback, viewCallback);
        }
    }
};

let productoManager = new ProductoManager();
export default productoManager;